import React, { ReactElement } from "react";
import Content from "./Content";

export default function Sub(props: any): ReactElement {
  const { children, align, type } = props;

  return (
    <sub style={{ ...(align && { textAlign: align }), marginBottom: "10px" }}>
      {" "}
      <Content contentValue={children} />
    </sub>
  );
}
